import {Component, OnInit} from '@angular/core';
import {IonCard, IonSkeletonText} from '@ionic/angular/standalone';

@Component({
    selector: 'app-error-card-skeleton-loading',
    templateUrl: './error-card-skeleton-loading.component.html',
    styleUrls: ['./error-card-skeleton-loading.component.css'],
    imports: [IonCard, IonSkeletonText],
    standalone: true,
})
export class ErrorCardSkeletonLoadingComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
    }

}
